export const pauseGame = () => {
	window.postMessage({ name: 'pause_gameplay' }, '*');
};

export const resumeGame = () => {
	window.postMessage({ name: 'resume_gameplay' }, '*');
};
